import {createAction} from 'redux-actions';

import actionTypes from './action-types';

export default {
    fetch: createAction(actionTypes.RECIPIENTS_FETCH, (type, extraData, successData) => ({
        type,
        extraData,
        successData,
    })),
    fetchSenders: createAction(actionTypes.RECIPIENTS_SENDERS_FETCH, (type, context) => ({type, context})),
};
